import { useSelector } from 'react-redux';
import { ExportMapModal } from './ExportMapModal';

export const Modals = ({ mapRef }) => {
  const modals = useSelector(state => state.modals);

  let modal;
  if (modals.showExportMapModal) {
    modal = <ExportMapModal mapRef={mapRef} />;
  }

  return <>{modal}</>;
};
